import { REPORT_URL } from "utils/constants";
import { ENDPOINTSREPORT } from "utils/endpoints";
import { http } from "utils/http";

export const getAllReportsDatabases= () => http({
    baseURL:REPORT_URL ,
    url:ENDPOINTSREPORT.Databases.browse,
    method:"get",

}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject( err);
});
export const reinitializeReportsDatabases= () => http({
    baseURL:REPORT_URL ,
    url:ENDPOINTSREPORT.Databases.reinitialize,
    method:"get",

}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject( err);
});
export const setAsDefault= (id) => http({
    baseURL:REPORT_URL ,
    url:ENDPOINTSREPORT.Databases.setAsDefault,
    method:"put",
    params:{
        id
    }

}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject( err);
});
